import type { FetchLike, WretchOptions } from "wretch";
import { IS_DEV } from "@/constants/normal";
import { getSid } from "@/services/sid";

const traceMiddleware = (next: FetchLike) => async (url: string, opts: WretchOptions) => {
  if (IS_DEV) {
    const sid = await getSid();

    console.info(`[Trace] client id: ${sid}, request url: ${url}`);
  }

  return next(url, opts);
};

export default traceMiddleware;
